import reduxStore from "../redux/store";
import {clearResource, setResource, setSaveStatusError} from "../redux/actions";
import {RestRequestGET, RestRequestPOST} from "../libs/RestRequest";
import Endpoints from "constants/Endpoints";
import Tr from "../translations/Translations";

const DEMAND_OFFERS_ACCESS_USERS = 'demandOffersAccessUsers'
const DEMAND_OFFERS_ACCESS_USERS_HISTORY = 'demandOffersAccessUsersHistory'

const getUsers = async (demandId, stageId) => {
    const resp = await RestRequestGET(Endpoints.DEMAND_OFFERS_ACCESS_USERS(demandId, stageId));
    reduxStore.dispatch(setResource(DEMAND_OFFERS_ACCESS_USERS, resp));
}

const giveAccess = async (demandId, stageId, payload) => {
    return await RestRequestPOST(Endpoints.DEMAND_OFFERS_ACCESS_USERS(demandId, stageId), payload);
}

const changeAdmin = async (demandId, stageId, payload) => {
    const resp = await RestRequestPOST(Endpoints.DEMAND_OFFERS_ACCESS_ADMIN(demandId, stageId), payload);
    if (!resp.success) {
        reduxStore.dispatch(setSaveStatusError(!!resp.errors && resp.errors.length > 0 ? resp.errors[0] : Tr('bad_request_error')));
    }
    return resp;
}

const getHistory = async (demandId, stageId) => {
    const resp = await RestRequestGET(Endpoints.DEMAND_OFFERS_ACCESS_HISTORY(demandId, stageId));
    reduxStore.dispatch(setResource(DEMAND_OFFERS_ACCESS_USERS_HISTORY, resp.result));
}

const clearResources = () => reduxStore.dispatch(clearResource(DEMAND_OFFERS_ACCESS_USERS));

const clearHistory = () => reduxStore.dispatch(clearResource(DEMAND_OFFERS_ACCESS_USERS_HISTORY));

export default {
    getUsers,
    clearResources,
    giveAccess,
    changeAdmin,
    getHistory,
    clearHistory
}